import { render, staticRenderFns } from "./UserPhysicalAddressFields.vue?vue&type=template&id=5ce4fafa&scoped=true"
import script from "./UserPhysicalAddressFields.vue?vue&type=script&lang=ts"
export * from "./UserPhysicalAddressFields.vue?vue&type=script&lang=ts"
import style0 from "./UserPhysicalAddressFields.vue?vue&type=style&index=0&id=5ce4fafa&prod&scoped=true&lang=css"
import style1 from "./UserPhysicalAddressFields.vue?vue&type=style&index=1&id=5ce4fafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4fafa",
  null
  
)

export default component.exports